import {Building} from '@lib/store';
import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';

export const SECTION_ID_BUILDINGS = 'SECTION_ID_BUILDINGS';

export const constructBuildingFilter = <TEntity extends {buildingId: string}>(
  buildings: Building[],
  defaultBuildingId: string,
  t: TFunction,
) =>
  constructFilter({
    sectionId: SECTION_ID_BUILDINGS,
    sectionTitle: t('workplace:Building'),
    type: 'singleMandatory',
    data: buildings.map(({id, name}) => ({id, label: name})),
    predicate: (filter, entity: TEntity) => filter.id === entity.buildingId,
    defaultFilterOptions: defaultBuildingId,
  });
